import { Award, BookOpen, Scale, Users, CheckCircle } from 'lucide-react';

const LIBRARY_IMG = "https://images.unsplash.com/photo-1765969934422-077ccae29246?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MTN8MHwxfHNlYXJjaHwzfHxsZWF0aGVyJTIwbGF3JTIwYm9va3MlMjBsaWJyYXJ5fGVufDB8fHx8MTc3MjM0MTIyOXww&ixlib=rb-4.1.0&q=85&w=800";

export const AboutSection = () => {
  const highlights = [
    {
      icon: Award,
      title: '35+ Years',
      description: 'Civil Litigation Experience'
    },
    {
      icon: Scale,
      title: 'High Court Practice',
      description: 'Before Patna High Court'
    },
    {
      icon: BookOpen,
      title: 'Bar Council',
      description: 'Enrolled with Bar Council of Bihar'
    },
    {
      icon: Users,
      title: 'Client Focus',
      description: 'Diligent Representation'
    }
  ];

  const values = [
    'Commitment to procedural integrity',
    'Diligent case preparation and research',
    'Professional responsibility in all matters',
    'Clear communication with clients',
    'Ethical practice standards',
    'Thorough understanding of civil law'
  ];

  return (
    <section 
      id="about" 
      className="py-20 lg:py-28 bg-[#F8F6F2]"
      data-testid="about-section"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <p className="text-[#C6A34A] uppercase tracking-widest text-sm font-medium mb-3">
            About the Advocate
          </p>
          <h2 
            className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#0B1C2D] mb-4"
            style={{ fontFamily: "'Playfair Display', serif" }}
          >
            Almost Four Decades of Legal Excellence
          </h2>
          <div className="w-20 h-1 bg-[#C6A34A] mx-auto" />
        </div>

        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Image */}
          <div className="relative">
            <div className="absolute -inset-4 bg-[#C6A34A]/10 transform -rotate-2" />
            <img 
              src={LIBRARY_IMG}
              alt="Legal Library - Professional legal practice"
              className="relative w-full h-[400px] lg:h-[500px] object-cover shadow-lg"
              data-testid="about-image"
            />
            {/* Overlay badge */}
            <div className="absolute bottom-6 right-6 bg-[#0B1C2D] px-6 py-4 shadow-xl">
              <p className="text-white text-sm uppercase tracking-wider">Practicing Since</p>
              <p className="text-[#C6A34A] text-3xl font-bold" style={{ fontFamily: "'Playfair Display', serif" }}>1987</p>
            </div>
          </div>

          {/* Content */}
          <div>
            <h3 
              className="text-2xl sm:text-3xl font-semibold text-[#0B1C2D] mb-6"
              style={{ fontFamily: "'Playfair Display', serif" }}
            >
              Adv. Ajeet Narayan Sinha
            </h3>
            
            <div className="w-16 h-1 bg-[#C6A34A] mb-6" />
            
            <p className="text-[#4A5568] text-base leading-relaxed mb-6">
              With almost four decades of dedicated practice in civil litigation, Adv. Ajeet Narayan Sinha 
              has established a reputation for thorough case preparation, procedural expertise, and 
              commitment to client interests before the Patna High Court and various civil courts in Bihar.
            </p>
            
            <p className="text-[#4A5568] text-base leading-relaxed mb-8">
              Enrolled with the Bar Council of Bihar, Advocate Sinha brings a wealth of experience 
              in handling complex civil matters including property disputes, contractual issues, 
              and civil appeals. His practice is guided by principles of professional responsibility 
              and ethical conduct.
            </p>

            {/* Values List */}
            <div className="grid sm:grid-cols-2 gap-3">
              {values.map((value, index) => (
                <div key={index} className="flex items-start space-x-3">
                  <CheckCircle className="w-5 h-5 text-[#C6A34A] mt-0.5 flex-shrink-0" />
                  <span className="text-[#2B2B2B] text-sm">{value}</span>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Highlights Grid */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 mt-16">
          {highlights.map((item, index) => (
            <div 
              key={index}
              className="bg-white p-6 border border-gray-100 shadow-sm hover:shadow-md hover:border-[#C6A34A]/30 transition-all duration-300"
              data-testid={`highlight-card-${index}`}
            >
              <div className="w-12 h-12 bg-[#C6A34A]/10 flex items-center justify-center mb-4">
                <item.icon className="w-6 h-6 text-[#C6A34A]" />
              </div>
              <h4 
                className="text-xl font-semibold text-[#0B1C2D] mb-2"
                style={{ fontFamily: "'Playfair Display', serif" }}
              >
                {item.title}
              </h4>
              <p className="text-[#718096] text-sm">{item.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
